import {
  OptionInstance,
  GhModelType,
  State as ViewerState,
  ViewerError,
  ViewerErrorType,
  ViewerSuccess,
} from '@swd_admin/cdc-viewer';
import { useNotificationStore } from 'state/notificationstate/notificationstate';
import { useUiState } from 'state/ui-state/ui-state';
import { useViewerState } from 'state/viewer-state/viewer-state';
import {
  cannotResizeBuildingError,
  notEnoughSpaceOptionError,
  handleGHModelParametersError,
  handleStyleDefinitionError,
  unknownParentError,
} from './error/handleParametersError';
const { setNotification } = useNotificationStore.getState();

export const onError = (e: ViewerError) => {
  const notificationHandlers: Record<ViewerErrorType, (error: any) => void> = {
    [ViewerErrorType.CannotResizeBuildingError]: cannotResizeBuildingError,
    [ViewerErrorType.NotEnoughSpaceOptionError]: notEnoughSpaceOptionError,
    [ViewerErrorType.SetGhModelParametersError]: handleGHModelParametersError,
    [ViewerErrorType.StyleDefinitionError]: handleStyleDefinitionError,
    [ViewerErrorType.UnknownParentError]: unknownParentError,
  };
  notificationHandlers[e.type](e);
};
export const onOptionClick = (
  instance: OptionInstance & { unDeletable?: boolean }
) => {
  if (window.location.pathname !== '/quote') {
    useUiState.getState().setActiveOption(instance);
  }
};
export const onStateChange = (state: ViewerState) => {
  useViewerState.getState().setViewerState(state);
};
export const onSuccess = (e: ViewerSuccess) => {
  setNotification(e.code.toString(), 'success', 'small');
};

export const onLoadingProgress = (
  ghModelType?: GhModelType,
  done?: boolean
) => {
  useUiState
    .getState()
    .setViewerLoadingModelType(!done ? ghModelType : undefined);
};
